import { Controller } from '@hotwired/stimulus';

// Liste en mode serveur (TableComponent) : à chaque rechargement de la Frame
// des lignes (recherche), nombre de résultats (cible count, dans la Frame)
// recopié dans la région annoncée (cible status, hors de la Frame).
export default class extends Controller {
    static targets = ['status', 'count'];

    announce() {
        if (this.hasCountTarget) this.statusTarget.textContent = this.countTarget.textContent;
    }
}
